import Tree from './Tree';
export default Tree;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/tree/index.js
// module id = 834
// module chunks = 0